// Shared utilities for Reports components

export const formatCurrency = (amount) => { 
  const num = parseFloat(amount) || 0; 
  return `${num < 0 ? '-' : ''}₹${Math.abs(num).toLocaleString('en-IN')}`; 
};

export const formatMonth = (monthStr) => { 
  if (!monthStr) return ''; 
  const [year, month] = monthStr.split('-'); 
  return new Date(year, parseInt(month) - 1, 1).toLocaleDateString('en-IN', { month: 'short', year: 'numeric' }); 
};
